import React, { useState } from 'react';
import { ButtonPrimary } from '../StyledComponent';
import EmailInput from '../Inputs/EmailInput';
import PasswordInput from '../Inputs/PasswordInput';
import HeaderSection from '../HeaderSection';
import { Container } from './styles';
import { useHistory } from 'react-router-dom';
const AccessData = ({
  tema,
  userData,
  haveAnyFieldsEditing,
  toggleEdit,
  handleCancel,
}) => {
  const [isEditable, setIsEditable] = useState(false);
  const history = useHistory();

  return (
    <div>
      <HeaderSection
        title={'Dados de acesso'}
        subtitle={
          'São as suas informações pessoais, é importante que estejam corretas e atualizadas:'
        }
        tema={tema}
        isEditable={isEditable}
        setIsEditable={setIsEditable}
        onEdit={toggleEdit}
        onCancel={handleCancel}
        marginTop={120}
        mobileMarginTop={80}
        haveAnyFieldsEditing={haveAnyFieldsEditing}
      />
      <Container>
        <div className='field'>
          <EmailInput value={userData.Email} disabled />
          <ButtonPrimary
            tema={tema}
            disabled={!isEditable}
            fullWidth
            onClick={() => history.push('/alterar-email')}
          >
            ALTERAR E-MAIL
          </ButtonPrimary>
        </div>
        <div className='field'>
          <PasswordInput value={'password'} />
          <ButtonPrimary
            tema={tema}
            fullWidth
            disabled={!isEditable}
            onClick={() => history.push('/alterar-senha')}
          >
            ALTERAR SENHA
          </ButtonPrimary>
        </div>
      </Container>
    </div>
  );
};

export default AccessData;
